<template>
    <div>999</div>
</template>

<script>

export default {
    props: ['value'],
    components:{

    },
    data() {
        return {
            
        }
    },

    watch: {
        value(val) {
            if(val) {
                
            }
        }
    },

    mounted() {
        
    },

    methods: {
        
    },

}
</script>
<style lang="scss" Scoped>
.TTL-switch {width:100%;text-align:right;}
</style>